import { EventEmitter } from "events";

import dispatcher from "../utils/dispatcher.js";
import * as Connection from "../utils/Connections";
import $ from "jquery";
class ProduceStore extends EventEmitter {
    constructor() {
        super();
        this.produce=[];
        this.viewProduce=[];

    }

    getAll(){
        return this.produce;
    }
    getInventoryData(){
        this.viewProduce.forEach(function (produce) {
            produce["displayPrice"]=produce.price
        })
        return this.viewProduce;
    }
    handleActions(action) {
        switch (action.type) {

            case "RECEIVE_ALL_PRODUCE":
            {

                this.produce=action.produceData.data;
                this.emit("change");
                break
            }
            case "RECEIVE_ALL_PRODUCE_VIEW_INVENTORY": {

                this.viewProduce=action.produceData;
                this.emit("change");

                break;
            }
        }
    }

}

const produceStore = new ProduceStore;
dispatcher.register(produceStore.handleActions.bind(produceStore));

export default produceStore;



// WEBPACK FOOTER //
// ./src/stores/ProduceStore.js